'use client';

import { Box, Stack } from '@mui/material';
import { H2 } from '@web/components/Typography';
import OfferTable from '@web/components/product-page/OfferTable';
import OfferTableMobile from '@web/components/product-page/OfferTableMobile';
import PriceTrend from '@web/components/product-page/PriceTrend';
import ProductReview from '@web/components/products/ProductReview';
import ProductReviewMobile from '@web/components/products/ProductReviewMobile';
import SpecTable from '@web/components/SpecTable';
import AdSenseAd from '@web/components/AdSenseAd';
import Notification from '@web/components/Notification';
import ProductSuggestions from './ProductSuggestions';
import { useState } from 'react';
import { TimeRange } from '@web/app/components/TimeRangeControls';

export default function OffersDisplay({ product, currentOffers, historicalOffers }) {
  const [timeRange, setTimeRange] = useState<TimeRange>('1M');

  return (
    <>
      <Stack sx={{ display: { xs: 'none', md: 'flex' } }}>
        <OfferTable
          offers={currentOffers}
          historicalOffers={historicalOffers}
          oz={product.oz}
          lastUpdatedAt={product.product_status?.last_price_updated_at}
          timeRange={timeRange}
          onTimeRangeChange={setTimeRange}
        />
        <Box mt={2} sx={{ height: 280 }}>
          <AdSenseAd adSlot="1042586257" fullWidth mobile={false} />
        </Box>
        <Box>
          <PriceTrend offers={currentOffers} timeRange={timeRange} />
          <>
            <ProductSuggestions />
            {product.reviews?.filter(Boolean)?.length > 0 && (
              <Box id="desktop-reviews">
                <H2 fontSize="1.25rem" my={2}>
                  Reviews
                </H2>
                <ProductReview reviews={product.reviews} />
              </Box>
            )}
            {(product.detail?.specs as any)?.length > 0 && (
              <Box id="desktop-specs" mb={4}>
                <H2 fontSize="1.25rem" mb={2}>
                  Specification
                </H2>
                <SpecTable specs={product.detail?.specs} />
              </Box>
            )}
            <Box mb={2} sx={{ height: 280 }}>
              <AdSenseAd adSlot="9749934028" fullWidth mobile={false} />
            </Box>
          </>
        </Box>
      </Stack>

      <Stack sx={{ display: { xs: 'flex', md: 'none' } }}>
        <OfferTableMobile
          offers={currentOffers}
          historicalOffers={historicalOffers}
          oz={product.oz}
          lastUpdatedAt={product.product_status?.last_price_updated_at}
          timeRange={timeRange}
          onTimeRangeChange={setTimeRange}
        />
        <Notification product={product} isMobile />
        <Box mt={2} sx={{ minHeight: 350 }}>
          <AdSenseAd adSlot="9460754442" mobile />
        </Box>
        <Box id="price_trend">
          <PriceTrend offers={currentOffers} isMobile timeRange={timeRange} />
        </Box>
        <ProductSuggestions isMobile />
        {product.reviews?.filter(Boolean).length > 0 && (
          <Stack>
            <H2 fontSize="1.25rem" my={1} id="reviews">
              Reviews
            </H2>
            <ProductReviewMobile reviews={product.reviews} />
          </Stack>
        )}
        {(product.detail?.specs as any)?.length > 0 && (
          <Box>
            <H2 fontSize="1.25rem" my={1}>
              Specification
            </H2>
            <SpecTable specs={product.detail?.specs} />
          </Box>
        )}
        <Box my={2} sx={{ minHeight: 350 }}>
          <AdSenseAd adSlot="9783090595" mobile />
        </Box>
      </Stack>
    </>
  );
}
